import {
  Box, Button, FormField, Image, Text,
} from '@domain-group/suit-theme'
import { useSetState } from '@domain-group/react-hooks'

import handleCallbackAction from '@functions/handleCallbackAction'

import useOrderItemTask, { useOrderItemTaskForm } from '@hooks/useOrderItemTask'

import DateSelectFieldWithDeadlines from '@components/DateSelectFieldWithDeadlines'
import TaskImageUpload from '@components/TaskImageUpload'

import type { OrderItemTaskModel } from '@models/orderItemTask'

const defaultState = {
  showReplaceImageUpload: false,
}

interface TaskProps {
  orderItemTask: OrderItemTaskModel,
}

const Task = (props: TaskProps) => {
  const { orderItemTask } = props

  const orderItemTaskPayload = useOrderItemTask(orderItemTask)
  const {
    callbacks: {
      hydrateOrderItemTask: hydrateFn,
      updateOrderItemTask: updateFn,
    },
    orderItem,
    orderItemTask: {
      instruction_image,
    },
    orderItemTaskType: {
      title: taskTypeTitle,
    },
    provider,
    taskColor,
    updating,
  } = orderItemTaskPayload

  const [state, setState] = useSetState(defaultState)
  const { showReplaceImageUpload } = state

  const formPayload = useOrderItemTaskForm(orderItemTask)
  const {
    entityState,
    entityState: {
      address,
      due_date,
      instructions,
    },
    handlers,
    saveEnabled,
    setEntityState,
  } = formPayload

  return (
    <Box border="1px solid" borderColor="lineColor" borderRadius={5} flexDirection="column" padding="large">
      <Box borderBottom="1px dashed" borderColor="lineColor" marginBottom="large" paddingBottom="large">
        <Text color={`#${taskColor}`} fontSize="small">
          {taskTypeTitle}
        </Text>
      </Box>

      <FormField label="* Task Address">
        <input name="address" value={address} type="text" {...handlers} />
      </FormField>

      <FormField label="* Task Date" marginTop="large">
        <DateSelectFieldWithDeadlines
          callbacks={{
            onChange: formattedDate => setEntityState({ due_date: formattedDate }),
          }}
          // @ts-expect-error TS2740
          provider={provider}
          // @ts-expect-error TS2339
          serviceId={orderItem.service_id}
          value={due_date}
        />
      </FormField>

      <FormField label="* Task Instructions" marginTop="large">
        {/*
         // @ts-expect-error TS2322 */}
        <textarea
          name="instructions"
          placeholder="Please include detailed instructions"
          style={{ height: 120 }}
          value={instructions}
          {...handlers}
        />
      </FormField>

      <FormField label="Installation Image" marginTop="large">
        {!!instruction_image && !showReplaceImageUpload && (
          <Image
            boxProps={{ alignItems: 'flex-end', justifyContent: 'flex-end', padding: 'large' }}
            height={186}
            url={instruction_image?.large}
          />
        )}

        {(!instruction_image || showReplaceImageUpload) && (
          <TaskImageUpload
            callbacks={{
              afterAction: (response) => {
                hydrateFn(response.body)
                setState({ showReplaceImageUpload: false })
              },
            }}
            orderItemTask={orderItemTask}
          />
        )}
      </FormField>

      {!!instruction_image && (
        <Button
          buttonStyle="secondaryUtility"
          // @ts-expect-error TS2322
          marginTop="large"
          onClick={() => setState({ showReplaceImageUpload: !showReplaceImageUpload })}
          size="medium"
        >
          {showReplaceImageUpload ? 'Cancel' : 'Change Image'}
        </Button>
      )}

      <Button
        buttonStyle="secondaryUtility"
        disabled={!saveEnabled}
        loading={updating}
        // @ts-expect-error TS2322
        marginTop={instruction_image ? 'small' : 'large'}
        onClick={() => handleCallbackAction({
          callbacks: {
            action: updateFn,
          },
          entityParams: entityState,
          toastText: 'Task Updated',
        })}
        size="medium"
      >
        Save Task
      </Button>
    </Box>
  )
}

export default Task
